import { Tab, Box, Tooltip, Flex } from '@chakra-ui/react'

import {
  DOPPEL_DARK_CLICKABLE,
  DOPPEL_INTERNAL_PURPLE,
  FONT_SIZE_MEDIUM,
} from '@/utils/style'
import CountBadge from '@/components/doppel_design/count_badge'
import { LockIcon } from '@chakra-ui/icons'
import { MORE_MODULES_TAB } from '@/utils/constants'

export type TabWarningInfo = {
  icon?: React.ReactNode
  tooltipText?: string
}

type MainTabProps = {
  name: string
  count?: number
  height?: number
  warningInfo?: TabWarningInfo
  tooltipText?: string
  isTrialTab?: boolean
}

export const MainTab: React.FC<MainTabProps> = ({
  name,
  count,
  height = 40,
  warningInfo,
  tooltipText,
  isTrialTab = false,
}: MainTabProps) => {
  const tab = (
    <Tab
      _hover={{ bg: DOPPEL_DARK_CLICKABLE }}
      _selected={{ bg: DOPPEL_DARK_CLICKABLE }}
      borderRadius={8}
      cursor="pointer"
      fontSize={FONT_SIZE_MEDIUM}
      height={`${height}px`}
      marginRight="16px"
      overflow="visible"
      padding="7px 8px"
      position="relative"
      sx={{
        ...(isTrialTab
          ? {
              border: `2px dashed ${DOPPEL_INTERNAL_PURPLE}`,
            }
          : undefined),
      }}
      whiteSpace="nowrap"
    >
      <Flex alignItems="center">
        {name === MORE_MODULES_TAB && <LockIcon mr={2} />}

        {name}
      </Flex>

      {count > 0 && <CountBadge count={count} />}

      {warningInfo?.icon && (
        <Tooltip label={warningInfo.tooltipText}>
          <Box padding="0 4px">{warningInfo.icon}</Box>
        </Tooltip>
      )}
    </Tab>
  )

  const trialTooltip = isTrialTab
    ? 'This module is being trialed by the organization.'
    : undefined

  const combinedTooltip =
    tooltipText && trialTooltip
      ? `${tooltipText}\n${trialTooltip}`
      : tooltipText || trialTooltip

  return combinedTooltip ? (
    <Tooltip label={combinedTooltip} placement="bottom">
      {tab}
    </Tooltip>
  ) : (
    tab
  )
}
